const ADJECTIVES = [
  '빠른', '날쌘', '용감한', '씩씩한', '당당한',
  '영리한', '지혜로운', '기발한', '신비로운', '우아한',
  '활발한', '귀여운', '멋진', '강한', '용맹한',
  '따뜻한', '상쾌한', '밝은', '조용한', '느긋한',
  '재빠른', '민첩한', '대담한', '차분한', '신나는',
  '놀라운', '반짝이는', '푸른', '붉은', '황금빛',
];

const ANIMALS = [
  // 맹수
  '호랑이', '사자', '표범', '치타', '늑대',
  '북극곰', '반달곰', '판다',
  // 친숙한 동물
  '여우', '너구리', '수달', '고슴도치', '미어캣',
  '다람쥐', '햄스터', '토끼',
  // 아프리카·동물원
  '코끼리', '기린', '얼룩말', '하마', '코뿔소',
  '캥거루', '코알라', '펭귄', '플라밍고',
  // 조류
  '독수리', '올빼미', '공작', '두루미', '황새',
  '앵무새', '매', '갈매기',
  // 해양
  '돌고래', '범고래', '상어', '해마', '문어',
  '해파리', '바다사자',
  // 파충류
  '카멜레온', '악어', '거북이',
];

// ADJECTIVES(30) × ANIMALS(50) = 1,500가지 조합
export function generateNickname(): string {
  const adj = ADJECTIVES[Math.floor(Math.random() * ADJECTIVES.length)];
  const animal = ANIMALS[Math.floor(Math.random() * ANIMALS.length)];
  return `${adj}${animal}`;
}
